import type { User } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaEnvelope, FaRegEnvelope } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { UserReinviteModal } from './UserReinviteModal';

interface Props {
  user: User;
}

export const UserReinviteMenuItem = (props: Props) => {
  const { user } = props;

  const onClick = () => {
    showModal(UserReinviteModal, { user });
  };

  return (
    <ChakraV3.MenuItem value='reinvite' onClick={onClick}>
      <FaRegEnvelope />
      Reinvite
    </ChakraV3.MenuItem>
  );
};
